const inputs = [...document.querySelectorAll('section.cart-products input[name="quantity"]')];

const refreshTimeout = 400; 

const setRefresh = {
	refreshTimer: '', 

	set: function() {
		if(this.refreshTimer)
			clearTimeout(this.refreshTimer); 

		this.refreshTimer = setTimeout(function(){
			location.reload();
		}, refreshTimeout); 
	}
}

const setListener = input => input.addEventListener('change', (e) => { setRefresh.set(); }); 

export default () => {
	if(inputs)
	{
		inputs.forEach(setListener); 
	}
}